import { rem } from "@mantine/core";
import { MantineSize } from "../mantine";

export const spacing: Record<MantineSize, string> = {
    xxs: rem(2),
    xs: rem(4),
    sm: rem(8),
    md: rem(12),
    lg: rem(16),
    xl: rem(24),
    xxl: rem(32),
};
